import { render, staticRenderFns } from "./CandidateSendLogField.vue?vue&type=template&id=d8d6f878&scoped=true&lang=pug&"
import script from "./CandidateSendLogField.vue?vue&type=script&lang=js&"
export * from "./CandidateSendLogField.vue?vue&type=script&lang=js&"
import style0 from "./CandidateSendLogField.vue?vue&type=style&index=0&id=d8d6f878&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d6f878",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VIcon,VTextarea})
